export default __webpack_public_path__ + "static/media/file-type-xls-icon.6cb793b5.svg";